// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f932eb97","239":"67404f04","453":"70db4db0","455":"330822af"}[chunkId] + ".chunk.js";
};